// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c8585ea391255a55","3397":"752055731adc1622","6312":"b0890047b18d4176","9232":"eebba2d6a8b88081"}[chunkId] + ".css";
};